import React, { useEffect } from 'react';

import birds from '../../assets/home/ave.png'
import mountain from '../../assets/home/mata01.png'
import mountain2 from '../../assets/home/mata01.png'
import logo from '../../assets/home/logo-marido.png'
import road from '../../assets/home/fusca01.png'

import './style.css'

function Home() {

    let bgScroll
    let birdsScroll
    let mountainScroll
    let mountain02Scroll
    let roadScroll
    let textScroll

    const scrolling = () => {
        var value = window.scrollY
        birdsScroll.style.marginLeft = value * 0.25 < 100 ? value * 0.25 + 'px' : 100
        birdsScroll.style.marginTop = -value * 0.9 + 'px'
        mountainScroll.style.marginTop = value * 0.15 + 'px'
        mountain02Scroll.style.marginTop = -value * 0.05 + 'px'
    }

    useEffect(() => {
        birdsScroll = document.getElementById('birds')
        mountainScroll = document.getElementById('mountain')
        mountain02Scroll = document.getElementById('mountain2')
        textScroll = document.getElementById('text')
        window.onscroll = () => scrolling()
    })

    return (
        <div id='home'>
            <section onScroll={e => window.addEventListener('scroll', scrolling)} className='Home'>
                <img src={logo} class='logo'></img>
                <h2 id='title' data-text='FrontEnd Developer'></h2>
                <h2 id='text'>Rafael Oliveira Duarte</h2>
                <img src={mountain2} id='mountain2' alt='' />
                <img src={mountain} id='mountain' alt='' />
                <img src={birds} id='birds' alt='' />
                <img src={road} id='road' alt='' />
            </section>
        </div>
    );
}

export default Home;